<template>
  <div :class="$style.box">
    <div v-for="item in bottomNavArray" :key="item.id" :class="$style.list">
      <img
        v-if="item.name == '发布按钮'"
        :src="item.images"
        @click="issueTopic(item.id)"
        alt="发布按钮"
      />
      <span
        v-else
        :class="`${'#' + item.url.split('#')[1] == currentRouteHash && $style.choose}`"
        @click="handleLinkTo(item)"
      >
        {{ item.name }}
      </span>
      <div
        v-if="unreadNumber > 0 && item.name == '消息' ? true : false"
        :class="$style['unread-number']"
      >
        {{ unreadNumber > 99 ? '99+' : unreadNumber }}
      </div>
    </div>
  </div>
</template>

<script>
let _this = '';
import { getBottomNav } from '@/api/app.js';
import { reportData } from '@/api/report';
import { getUserUnreadNumber } from '@/api/personalCenter';
import { localLinkJump } from '@/utils/index.js';
export default {
  data() {
    return {
      bottomNavArray: [],
      routeType: 0,
      currentRouteHash: window.location.hash,
      unreadNumber: '', // 未读消息数
    };
  },
  computed: {
    circleId() {
      return this.$route.query.circleId || '';
    },
  },
  watch: {
    $route: {
      handler() {
        this.currentRouteHash = window.location.hash;
        this.getUserUnreadNumber();
      },
      deep: true,
    },
  },
  created() {
    _this = this;
    this.getBottomNav().then(() => {
      this.dataReport();
    });
    this.getUserUnreadNumber();
  },
  methods: {
    // 数组排序(升序)
    sortArray(array) {
      if (!(array instanceof Array)) {
        return;
      }
      let sortArray = [...array];
      sortArray.sort((a, b) => {
        if (a.sort < b.sort) {
          return -1;
        } else if (a.sort > b.sort) {
          return 1;
        }
        return 0;
      });
      return sortArray;
    },
    // 获取底部导航栏
    async getBottomNav() {
      const r = await getBottomNav();
      this.bottomNavArray = [...r.data].reverse();
    },
    async handleLinkTo(item) {
      try {
        const r = await reportData({
          type: 6,
          navigation_id: item.id,
        });
      } catch (error) {
        console.log(error);
      }
      // 外部链接跳转
      if (item.url_type == 2) {
        window.open(item.url, '_self');
        return;
      } else {
        // 内部链接跳转
        localLinkJump(item.url);
      }
    },
    // 点击发布按钮
    issueTopic(id) {
      reportData({
        type: 6,
        navigation_id: id,
      });
      // 2021.11.26 删除了在外页面发布帖子的功能
      if (this.$route.name !== 'gameCircle.home') {
        this.$toast.fail('请去圈子发帖');
        return;
      }
      this.$emit('showTopicField');
    },
    // 获取未读消息数
    async getUserUnreadNumber() {
      const r = await getUserUnreadNumber();
      if (window.location.hash === '#/personalCenter/myNews') {
        this.unreadNumber = 0;
      } else {
        this.unreadNumber = r.data.num;
      }
    },
    // 首次进入页面导航数据上报
    async dataReport() {
      let findItem = this.bottomNavArray.find(
        (item) => '#' + item.url.split('#')[1] == this.currentRouteHash,
      );
      if (findItem) {
        const r = await reportData({
          type: 6,
          navigation_id: findItem.id,
        });
      }
    },
  },
};
</script>

<style lang="scss" module>
.box {
  position: fixed;
  z-index: 98;
  left: 0;
  bottom: 0;
  display: flex;
  width: 100%;
  height: 52px;
  background-color: #fff;
  box-shadow: -3px 0px 10px rgba(159, 159, 159, 1);
  display: flex;
  justify-content: space-around;
  .list {
    width: 81px;
    height: 52px;
    line-height: 52px;
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    color: rgba(159, 159, 159, 1);
    position: relative;
    > img {
      width: 51px;
    }
    .choose {
      font-size: 16px;
      color: rgba(255, 130, 50, 1);
    }
    .unread-number {
      position: absolute;
      right: 8px;
      top: 6px;
      width: 20px;
      height: 13px;
      display: inline-block;
      background: rgba(245, 42, 42, 1);
      border-radius: 6px;
      font-size: 8px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      text-align: center;
      line-height: 13px;
    }
  }
}
</style>
